var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconoCrono(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "83px",
    height: "36px",
    viewBox: "0 0 83 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icono-4@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-8.92140666%",
    y1: "75.011798%",
    x2: "200.44843%",
    y2: "-13.8508731%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D436",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C536",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE9D35",
    offset: "34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D75D33",
    offset: "62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF2232",
    offset: "86%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-104.221427%",
    y1: "133.585223%",
    x2: "335.322134%",
    y2: "-104.912969%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D436",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C536",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE9D35",
    offset: "34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D75D33",
    offset: "62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF2232",
    offset: "86%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-119.612934%",
    y1: "121.967909%",
    x2: "89.7569035%",
    y2: "33.1288344%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D436",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C536",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE9D35",
    offset: "34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D75D33",
    offset: "62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF2232",
    offset: "86%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-96.0910973%",
    y1: "210.462301%",
    x2: "176.63073%",
    y2: "-88.9863386%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D436",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C536",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE9D35",
    offset: "34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D75D33",
    offset: "62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF2232",
    offset: "86%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-262.74577%",
    y1: "219.728294%",
    x2: "176.443188%",
    y2: "-18.7591205%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D436",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C536",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE9D35",
    offset: "34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D75D33",
    offset: "62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF2232",
    offset: "86%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-339.978601%",
    y1: "261.790828%",
    x2: "100.872868%",
    y2: "22.2257184%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6D436",
    offset: "3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8C536",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE9D35",
    offset: "34%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D75D33",
    offset: "62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF2232",
    offset: "86%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols-DIC",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elementos-/-icono-4",
    transform: "translate(1, -23)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icono-4",
    transform: "translate(-1, 23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5008261,36 L9.50767052,36 C4.25672909,36 0,31.7442753 0,26.4945729 L0,9.50542709 C0,4.25904022 4.25155093,0.00468846012 9.49917394,0 L26.4923295,0 C31.7413293,0.00468341312 35.9953155,4.25766582 36,9.50542709 L36,26.4945729 C35.9953247,31.7390228 31.7465075,35.990637 26.5008261,36 Z M9.50767052,2.99858424 C5.91319229,2.99858424 2.99929195,5.91179701 2.99929195,9.50542709 L2.99929195,26.4945729 C2.99929195,30.0848883 5.90801428,32.9967287 9.49917394,33.001438 L26.4923295,33.001438 C28.2214012,33.0059293 29.8812017,32.3223819 31.1054372,31.1016226 C32.3296727,29.8808633 33.0177012,28.2232425 33.0177012,26.4945729 L33.0177012,9.50542709 C33.0177012,5.91511174 30.1089789,3.00327133 26.5178192,2.99858424 L9.50767052,2.99858424 Z",
    id: "Shape",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1938042,13.744289 C21.063536,12.5503945 22.5071544,11.8937002 23.9954522,12.0149396 C25.4866231,11.8907086 26.93416,12.5477383 27.8054739,13.744289 C28.6657298,15.1704091 29.0766148,16.8153885 28.9861619,18.4711775 C29.0827723,20.1457909 28.6718623,21.8109326 27.8054739,23.255711 C26.93416,24.4522617 25.4866231,25.1092914 23.9954522,24.9850604 C22.5071544,25.1062998 21.063536,24.4496055 20.1938042,23.255711 C19.3306442,21.8156738 18.9198518,20.1567391 19.0131162,18.4876475 C18.9193089,16.8263343 19.3303131,15.1751444 20.1938042,13.744289 L20.1938042,13.744289 Z M25.6115713,15.7618634 C25.3500328,15.124409 24.690573,14.7346138 23.9954522,14.8066037 C23.302622,14.7356263 22.6461113,15.1256995 22.3877068,15.7618634 C22.0845103,16.6326093 21.9509901,17.5517723 21.9941441,18.4711775 C21.985327,19.1299991 22.0329461,19.7883806 22.1364966,20.4393419 C22.204799,20.9019356 22.4051504,21.3359801 22.7142801,21.6910615 C23.048187,22.0292333 23.5175039,22.2041979 23.9954522,22.1686913 C24.475076,22.1988238 24.9447487,22.0248635 25.284998,21.6910615 C25.5820499,21.3321865 25.7706405,20.8984782 25.8292868,20.4393419 C25.9328373,19.7883806 25.9804564,19.1299991 25.9716393,18.4711775 C26.02146,17.5540036 25.899409,16.6356365 25.6115713,15.7618634 L25.6115713,15.7618634 Z",
    id: "Shape",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19380422,13.744289 C9.06353603,12.5503945 10.5071544,11.8937002 11.9954522,12.0149396 C13.4866231,11.8907086 14.93416,12.5477383 15.8054739,13.744289 C16.6657298,15.1704091 17.0766148,16.8153885 16.9861619,18.4711775 C17.0827723,20.1457909 16.6718623,21.8109326 15.8054739,23.255711 C14.93416,24.4522617 13.4866231,25.1092914 11.9954522,24.9850604 C10.5071544,25.1062998 9.06353603,24.4496055 8.19380422,23.255711 C7.33064417,21.8156738 6.91985176,20.1567391 7.01311619,18.4876475 C6.91930886,16.8263343 7.33031305,15.1751444 8.19380422,13.744289 L8.19380422,13.744289 Z M13.6115713,15.7618634 C13.3500328,15.124409 12.690573,14.7346138 11.9954522,14.8066037 C11.302622,14.7356263 10.6461113,15.1256995 10.3877068,15.7618634 C10.0845103,16.6326093 9.95099008,17.5517723 9.99414412,18.4711775 C9.98532701,19.1299991 10.0329461,19.7883806 10.1364966,20.4393419 C10.204799,20.9019356 10.4051504,21.3359801 10.7142801,21.6910615 C11.048187,22.0292333 11.5175039,22.2041979 11.9954522,22.1686913 C12.475076,22.1988238 12.9447487,22.0248635 13.284998,21.6910615 C13.5820499,21.3321865 13.7706405,20.8984782 13.8292868,20.4393419 C13.9328373,19.7883806 13.9804564,19.1299991 13.9716393,18.4711775 C14.02146,17.5540036 13.899409,16.6356365 13.6115713,15.7618634 L13.6115713,15.7618634 Z",
    id: "Shape-Copy",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5008261,36 L56.5076705,36 C51.2586707,35.9953166 47.0046845,31.7423342 47,26.4945729 L47,9.50542709 C47.0046753,4.26097719 51.2534925,0.00936300985 56.4991739,0 L73.4923295,0 C78.7432709,0 83,4.25572467 83,9.50542709 L83,26.4945729 C83,31.7409598 78.7484491,35.9953115 73.5008261,36 L73.5008261,36 Z M56.5076705,2.99856203 C54.7785988,2.99407074 53.1187983,3.67761809 51.8945628,4.89837738 C50.6703273,6.11913667 49.9822988,7.77675747 49.9822988,9.50542709 L49.9822988,26.4945729 C49.9822988,30.0848883 52.8910211,32.9967287 56.4821808,33.001438 L73.4753363,33.001438 C75.204408,33.0059293 76.8642085,32.3223819 78.088444,31.1016226 C79.3126796,29.8808633 80.000708,28.2232425 80.000708,26.4945729 L80.000708,9.50542709 C80.000708,5.91511174 77.0919857,3.00327133 73.5008261,2.99856203 L56.5076705,2.99856203 Z",
    id: "Shape",
    fill: "url(#linearGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.558534,16.9585502 C39.193642,16.6486526 38.9899954,16.2048211 39.0005472,15.7424626 C38.9904145,15.2725684 39.1933149,14.8208192 39.558534,14.5001285 C39.9548077,14.1627717 40.4751837,13.9838987 41.0092998,14.0014451 C41.5381846,13.9818954 42.0535611,14.1613506 42.441466,14.5001285 C42.8066851,14.8208192 43.0095855,15.2725684 42.9994528,15.7424626 C43.0100046,16.2048211 42.806358,16.6486526 42.441466,16.9585502 C42.0526251,17.2949935 41.5370354,17.4713734 41.0092998,17.4484847 C40.47631,17.469346 39.9557363,17.2935444 39.558534,16.9585502 Z M39.558534,24.5087917 C39.1956726,24.1975283 38.9924447,23.7546093 39.0005472,23.2927041 C38.9880131,22.8223789 39.1913125,22.3697414 39.558534,22.05037 C39.9548077,21.7130132 40.4751837,21.5341402 41.0092998,21.5516867 C41.5381846,21.5321369 42.0535611,21.7115921 42.441466,22.05037 C42.8086875,22.3697414 43.0119869,22.8223789 42.9994528,23.2927041 C43.0075553,23.7546093 42.8043274,24.1975283 42.441466,24.5087917 C42.0499698,24.8411035 41.5362495,25.0168439 41.0092998,24.9987262 C40.4769114,25.0159271 39.9577469,24.8406013 39.558534,24.5087917 Z",
    id: "Shape",
    fill: "url(#linearGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1928411,13.7445039 C56.0645539,12.5493197 57.510121,11.8926841 58.999789,12.0152327 C60.4923267,11.8896925 61.9418093,12.5466628 62.8151039,13.7445039 C63.6680187,15.1729411 64.0753675,16.816664 63.9864724,18.4711788 C64.0815146,20.1445282 63.6741381,21.8084096 62.8151039,23.2554961 C61.943391,24.4506803 60.4978239,25.1073159 59.0081559,24.9847673 C57.5156183,25.1103075 56.0661357,24.4533372 55.1928411,23.2554961 C54.3303774,21.8155239 53.9199164,20.1566642 54.0131056,18.4876481 C53.919374,16.82641 54.3300466,15.1752946 55.1928411,13.7445039 Z M60.6146043,15.7619871 C60.2955007,15.1763453 59.6750016,14.810878 58.999789,14.810878 C58.3245764,14.810878 57.7040774,15.1763453 57.3849738,15.7619871 C57.0746684,16.6315414 56.9300102,17.549973 56.9582609,18.4711788 C56.9494509,19.1299706 56.9970316,19.7883224 57.1004985,20.4392542 C57.1766436,20.8995121 57.3759052,21.3315247 57.6778159,21.6909173 C58.4143487,22.3293602 59.518294,22.3293602 60.2548268,21.6909173 C60.5572802,21.3327969 60.7540766,20.8998545 60.8237773,20.4392542 C60.931439,19.7887979 60.9790459,19.1300843 60.9660149,18.4711788 C61.0177345,17.5545799 60.8986372,16.6364017 60.6146043,15.7619871 L60.6146043,15.7619871 Z",
    id: "Shape",
    fill: "url(#linearGradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1676004,13.7230145 C68.1248602,12.629047 69.5184484,12 70.9847599,12 C72.4510715,12 73.8446597,12.629047 74.8019194,13.7230145 C75.6647351,15.1555143 76.0768427,16.8078524 75.9861207,18.4710486 C76.0830186,20.1531533 75.6708859,21.825744 74.8019194,23.2769855 C73.8446597,24.370953 72.4510715,25 70.9847599,25 C69.5184484,25 68.1248602,24.370953 67.1676004,23.2769855 C66.3103434,21.8221721 65.9099574,20.149811 66.0169935,18.4710486 C65.9161413,16.8111954 66.3165018,15.1590889 67.1676004,13.7230145 Z M72.6014887,15.7496144 C72.2811771,15.1613262 71.6583292,14.7942073 70.9805606,14.7942073 C70.3027921,14.7942073 69.6799442,15.1613262 69.3596326,15.7496144 C69.0631497,16.6259001 68.9322089,17.5482768 68.9732975,18.4710486 C68.9644541,19.1328174 69.0122149,19.7941442 69.1160735,20.4480175 C69.1845792,20.9126806 69.3855268,21.3486668 69.6955763,21.7053366 C70.0304768,22.0450213 70.5011902,22.2207686 70.9805606,22.1851031 C71.4616116,22.2153704 71.9326818,22.0406319 72.2739436,21.7053366 C72.5839931,21.3486668 72.7849407,20.9126806 72.8534464,20.4480175 C72.957305,19.7941442 73.0050658,19.1328174 72.9962224,18.4710486 C73.035373,17.5477299 72.901564,16.6252036 72.6014887,15.7496144 L72.6014887,15.7496144 Z",
    id: "Shape",
    fill: "url(#linearGradient-6)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoCrono);
export default __webpack_public_path__ + "static/media/icono-crono.075bc035822f7274f278f81bcdb2095f.svg";
export { ForwardRef as ReactComponent };